<template>
    <div>
        <div class="popup__header">
            <span class="title title--sm popup__title">Добавление E-mail</span>
            <div class="popup__description">
                <span class="add__lock-text">Данное действие требует наличие e-mail адреса</span>
            </div>
        </div>
        <div class="popup__content">
            <form class="form" @submit.prevent="onSubmit">
                <div class="form__item">
                    <label class="form__inner">
                        <span class="form__label">E-mail</span>

                        <el-popover :value="errors.email.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.email.message">
                            <el-input slot="reference" :class="{ 'add__error': errors.email.isErrorPaint }"
                                      @focus="clearErrors"
                                      placeholder="E-mail"
                                      class="input input--big"
                                      v-model="form.email"
                                      required>

                            </el-input>
                        </el-popover>
                    </label>
                </div>
                <div class="form__item">
                    <button class="btn btn--middle btn--main-bg">{{ $lang('pagePassword.save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import width from "../mixins/width";
import ApiService from "../api/api";
import errors from '../mixins/errors';

export default {
    name: "SetEmailPopup",
    mixins: [width, errors],
    props: {
        profile: {
            default: null,
            type: Object
        }
    },
    data() {
        return {
            form: {
                email: ''
            },
            user: window.laravel.user,
            errors: {
                email: {
                    isError: false,
                    message: ''
                },
            }
        }
    },
    methods: {
        onSubmit() {
            this.$loading(this.$optionsLoading);

            ApiService.post('/mini-profile/set-email', this.form).then((response) => {
               this.onSuccess();
            }).catch(error => {
                this.createErrors(error.response.data.errors);
            }).finally(() => {
                this.$loading({}).close();
            });
        },
        onSuccess() {
            if (this.profile) {
                ApiService.post('/memories/' + this.profile.slug + '/subscribe').then((response) => {
                    location.href = '/memories/' + this.profile.slug;
                }).catch((errors) => {
                    console.log(error.response.data);
                })
            }
        }
    }
}
</script>

<style>
.popup__description {
    margin-top: 15px;
}
</style>
